<template>
  <div>
    <div class="float-right">
      <a href="/management/system-flow/create" class="m-2 collapsed" aria-expanded="false" aria-controls="sidebar-new" style="overflow-anchor: none;"
        ><i class="mdi mdi-plus"></i> {{ $t("system-flow.new") }}
      </a>
    </div>

    <div>
      <h2>{{ $t("system-flow.library") }}</h2>
    </div>

    <div class="bg-white">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 100px">
              <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>
                <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <td style="width: 150px">{{ $t("system-flow.active") }}</td>
            <td>{{ $t("product.text") }}</td>
            <td>{{ $t("system-flow.name") }}</td>
            <td>{{ $t("system-flow.when.text") }}</td>
            <th scope="col" style="width: 15%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th></th>
            <th></th>
            <th><input class="form-control " v-model="nameFilter" /></th>
            <th></th>
            <th></th>
          </tr>
          <template v-if="pagination">
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td :class="item.active ? 'text-success' : 'text-muted'"><i class="fa fa-bolt"></i> {{ item.active ? $t("common.yes") : $t("common.no") }}</td>
              <td>{{ item.products.join(", ") }}</td>
              <td>{{ item.name | translate }}</td>
              <td>
                <span v-if="item.when == 'ORGANIZATION_CREATED'">Organizasyon Oluşturulduğunda</span>
                <span v-if="item.when == 'DEPARTMENT_CREATED'">Birim Oluşturulduğunda</span>
                <span v-if="item.when == 'PROCESS_CREATED'">Faaliyet Oluşturulduğunda</span>
                <span v-if="item.when == 'DATASOURCE_CREATED'">Veri Kaynağı Oluşturulduğunda</span>
                <span v-if="item.when == 'DATASOURCE_UPDATED'">Veri Kaynağı Güncellendiğinde</span>
                <span v-if="item.when == 'DATASOURCE_PHYSICAL_ARCHIVE_CREATED'">Fiziksel Arşiv Ortamı, Veri Kaynağı ile ilişkilendirildiğinde</span>
                <span v-if="item.when == 'DATASOURCE_PHYSICAL_STORAGE_CREATED'">Fiziksel Saklama Ortamı, Veri Kaynağı ile ilişkilendirildiğinde</span>
                <span v-if="item.when == 'ORGANIZATION_MEMBER_JOINED'">Organizasyona Davet Edilen Kişi Organizasyona Erişebilir Olduğunda</span>
                <span v-if="item.when == 'ORGANIZATION_MEMBER_ROLE_CHANGED'">Organizasyon Üyesinin Rolü Değiştiğinde</span>
                <span v-if="item.when == 'ROADMAP_STAGE_COMPLETED'">Roadmap Aşaması Tamamlandığında</span>
                <span v-if="item.when == 'POLICY_STATUS_CHANGED'">Tedbir Statusü Değiştiğinde</span>
                <span v-if="item.when == 'DATASUBJECT_CREATED'">İlgili Kişi Oluşturulduğunda</span>
                <span v-if="item.when == 'DATASOURCE_COLLECT_MINIMIZED'">Veri Kaynağı, Toplama Minimizasyonuna Uğradığında</span>
                <span v-if="item.when == 'DATA_COLLECT_MINIMIZED'">Veri, Toplama Minimizasyonuna Uğradığında</span>
                <span v-if="item.when == 'DATASUBJECT_TRANSFER_MINIMIZED'">İlgili Kişi, Aktarım Minimizasyonuna Uğradığında</span>
                <span v-if="item.when == 'DATASOURCE_TRANSFER_MINIMIZED'">Veri Kaynağı, Aktarım Minimizasyonuna Uğradığında</span>
                <span v-if="item.when == 'THIRDPARTY_CREATED'">3. Taraf Oluşturulduğunda</span>
                <span v-if="item.when == 'THIRDPARTY_DELETED'">3. Taraf Silindiğinde</span>
              </td>

              <td>
                <div class="font-size-16 text-center" v-if="selectedItems.length == 0">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
                  <i class="bx bx-pencil text-primary hand" v-b-tooltip.hover :title="$t('common.edit')" @click="edit(item)"></i>
                </div>
              </td></tr
          ></template>
        </tbody>
      </table>
    </div>

    <b-modal id="modal-multiple-delete-operation" centered :title="$t('common.multiple-delete-operation')" hide-footer>
      <div v-if="deleteOperationResult.success.length > 0">
        <h5 class="text-success">{{ $t("common.delete-items") }}</h5>
        <ul>
          <li v-for="item in deleteOperationResult.success" :key="item.id">
            {{ item | translate }}
          </li>
        </ul>
      </div>

      <div v-if="deleteOperationResult.failed.length > 0">
        <h5 class="text-danger mt-4">{{ $t("common.delete-failed") }}</h5>
        <ul>
          <li v-for="item in deleteOperationResult.failed" :key="item.id">
            <b> {{ item.name | translate }}</b>
            {{ item.error }}
          </li>
        </ul>
      </div>
    </b-modal>

    <content-loading v-if="loading" />

    <empty v-if="!loading && (!pagination || pagination.docs.length == 0)">
      <h5 class="text-center" id="myText">
        {{ $t("common.no-data") }}
      </h5>
    </empty>

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
const state = "managementSystemFlow";

export default {
  components: {},
  data() {
    return {
      request: {
        options: { page: 1, limit: 15 },
        query: {},
      },
      nameFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    nameFilter(n, o) {
      this.request.query = {
        ...this.request.query,
        name: { value: n },
      };
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    deleteOperationResult() {
      return this.$store.getters[`${state}/deleteOperationResult`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },

    edit(item) {
      window.location = `/management/system-flow/${item._id}`;
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
      }
    },

    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/multipleDelete`, selectedItems);
        this.init();
        this.selectedItems = [];
        this.$root.$emit("bv::show::modal", "modal-multiple-delete-operation");
      } catch (error) {
        console.error(error);
      }
    },

    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
  },
};
</script>
